// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"865":"landing-layout","908":"landing-view"}[chunkId] + "." + {"865":"be2a10c6","908":"92a29b36"}[chunkId] + ".js";
};